// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8-3w3"};